export const careerSourceLabel = (row) =>
	({
		import: "Import " + (row.provider || "custom"),
		manual: "Manuale",
		report: "Segnalazione",
		valuation: "Valutazione",
	})[row.source] || "Storico";
export const preparePlayerCareer = (rows = []) =>
	rows.map((row) => ({
		...row,
		readable:
			row.readOnly === true ||
			row.id === "00000000-0000-0000-0000-000000000000",
	}));
